import type { Mission } from '../missions.ts'

export const fema: Mission = {
  id: "fema",
  name: "Federal Emergency Management Agency",
  short: "FEMA",
  call: "Emergency",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.fema.gov/",
  established: 1979,
  palette: {
    primary: "#002768",
    secondary: "#94bce7",
    accent: "#ffdc00",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Federal_Emergency_Management_Agency.svg",
  },
  motif: "eagle",
  mission: {
    text: "Our mission is helping people before, during and after disasters.",
    url: "https://www.fema.gov/about",
  },
  fact: {
    text: "President Carter signed Executive Order 12127, effective April 1, 1979, establishing FEMA.",
    url: "https://www.fema.gov/about/history",
  },
  seal: {
    file: "public/seals/fema.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Federal_Emergency_Management_Agency.svg",
  },
  identifier: {
    about: "https://www.fema.gov/about",
    accessibility: "https://www.fema.gov/accessibility",
    foia: "https://www.fema.gov/foia",
    noFear: "https://www.fema.gov/about/organization/equal-rights/no-fear-act",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.fema.gov/about/reports-and-data/annual-reports",
    privacy: "https://www.fema.gov/about/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/fema-north-dakota-flood.jpg",
        small: "/media/fema-north-dakota-flood-sm.jpg",
        alt: "Aerial view of flooded farmland and homes along the Red River of the North, with water surrounding houses and stands of bare trees.",
        title: "Aerial of flooding near Oxbow, North Dakota, March 28, 2009",
        creator: "Andrea Booher, FEMA",
        source: "https://commons.wikimedia.org/wiki/File:FEMA_-_40510_-_Aerial_of_flooding_in_North_Dakota.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/fema-tennessee-flood.jpg",
        small: "/media/fema-tennessee-flood-sm.jpg",
        alt: "Aerial view of a row of houses standing in brown floodwater, with treetops breaking the surface.",
        title: "Aerial preliminary damage assessment over Dyersburg, Tennessee, May 4, 2010",
        creator: "David Fine, FEMA",
        source: "https://commons.wikimedia.org/wiki/File:FEMA_-_43942_-_Aerial_of_flooding_in_Tennessee.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
